export default __webpack_public_path__ + "static/media/Foto-24.3aa7403e.png";